"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameUseBase = void 0;
const GameUserBaseIdentifierType_1 = require("../../enums/game/GameUserBaseIdentifierType");
exports.gameUseBase = {
    identifierType: GameUserBaseIdentifierType_1.GameUserBaseIdentifierType.UNIQUE_BROWSER,
    isEnable: false,
    formTitleText: 'Fill in this form to start playing',
    formStyle: {
        color: '000000',
        fontSize: '16px',
        textAlign: 'center',
        backgroundColor: 'ffffff',
    },
    termsText: 'By starting the game you accept our Terms & Conditions',
    isTermsRequired: true,
    termsTextStyle: {
        color: '000000',
        fontSize: '16px',
        textAlign: 'left',
    },
    submitButtonText: 'START GAME',
    submitButtonStyle: {
        color: 'ffffff',
        fontSize: '24px',
        backgroundColor: '46bb97',
    },
    additionalTerms: [
        {
            terms: '',
            isOptional: true,
            name: 'terms1',
            internalName: 'terms1',
        },
    ],
};
